import { ArrowDown, ArrowRight, MapPin } from "lucide-react";
import { CV } from "@/data/cv";

export default function Hero() {
  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen pt-28 md:pt-32 pb-16 overflow-hidden bg-grid"
    >
      {/* Top meta */}
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-center justify-between gap-4 font-mono-acc text-[11px] md:text-xs text-[#525252]">
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-full bg-[#FF3B00] animate-pulse" />
            <span>Verfügbar für Festanstellung — 2026</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5" />
            <span>{CV.location}</span>
          </div>
        </div>

        {/* Massive name */}
        <div className="mt-10 md:mt-16">
          <p data-testid="hero-role" className="font-mono-acc text-xs md:text-sm text-[#0F0F0F] mb-6">
            // Portfolio · Marketing & Social Media · TikTok
          </p>
          <h1
            data-testid="hero-name"
            className="font-display uppercase text-[11vw] md:text-[8.5vw] lg:text-[7.2vw] leading-[0.9] tracking-tighter pop-in"
            style={{ animationDelay: "0.05s" }}
          >
            <span className="block">SUDE</span>
            <span className="block">
              DILARA
              <span className="inline-block align-middle mx-2 md:mx-4 w-[0.6em] h-[0.18em] bg-[#FF3B00]" />
            </span>
            <span className="block">
              AKÇAGÖZ<span className="text-[#FF3B00]">.</span>
            </span>
          </h1>
        </div>

        {/* Sub row */}
        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6 items-end">
          <div className="md:col-span-7">
            <p className="font-display uppercase text-xl md:text-3xl leading-tight">
              Marketing,{" "}
              <span className="italic font-medium text-[#525252]">Influencer Strategy</span> &<br />
              TikTok Creative — aus Berlin in die Welt.
            </p>
          </div>
          <div className="md:col-span-5 md:pl-8 md:border-l-2 border-black">
            <p className="text-sm md:text-base text-[#0F0F0F] leading-relaxed">
              Ich entwickle Content, der scrollt, klickt und konvertiert. Datengetrieben.
              Trendscharf. Unverwechselbar.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                data-testid="hero-contact-btn"
                onClick={() => handleScroll("kontakt")}
                className="group inline-flex items-center gap-3 px-6 py-3 bg-[#FF3B00] text-white border-2 border-black shadow-brutal hover:translate-y-[2px] hover:shadow-brutal-press transition-all font-mono-acc text-xs"
              >
                Nachricht senden
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                data-testid="hero-download-cv-btn"
                href={CV.cvFile}
                download
                className="group inline-flex items-center gap-3 px-6 py-3 bg-[#F4F4F0] text-black border-2 border-black shadow-brutal hover:translate-y-[2px] hover:shadow-brutal-press transition-all font-mono-acc text-xs"
              >
                CV herunterladen
                <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom marquee strip */}
      <div className="mt-16 md:mt-24 border-y-2 border-black bg-black text-[#F4F4F0] py-3.5 overflow-hidden">
        <div className="flex marquee-track-slow whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="flex items-center gap-12 px-12 font-display uppercase text-xl md:text-3xl">
              <span>TikTok Strategy</span>
              <span className="text-[#525252]">·</span>
              <span>Influencer Marketing</span>
              <span className="text-[#525252]">·</span>
              <span>SEA · SEO</span>
              <span className="text-[#525252]">·</span>
              <span>Content Creation</span>
              <span className="text-[#525252]">·</span>
              <span>Brand Storytelling</span>
              <span className="text-[#525252]">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
